import { fetcher } from '@shared/fetcher';
import { CategorySchema, ICategory } from '@shared/types.ts';

export async function fetchAllSubcategories(url: string) {
  const res = await fetcher.get<{ data: (ICategory & { children: ICategory[] })[] }>(url).catch(() => null);

  if (!res?.data) return undefined;
  return res?.data.data.filter((i) => CategorySchema.isValidSync(i));
}
